import React from "react";
import { Form, Input, Select, Upload, Divider } from "antd";
import { RiLoaderLine, RiAddLine } from "react-icons/ri";

const LeftCol = ({
  loading,
  values,
  setValues,
  handleFormChange,
  categories,
  plans,
  handleUploadImage,
  beforeImageUpload,
}) => {
  const uploadButton = (
    <div>
      {loading ? (
        <RiLoaderLine
          className="remix-icon-loading remix-icon-spin remix-icon"
          size={24}
        />
      ) : (
        <RiAddLine size={24} />
      )}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <>
      <Form
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 15,
        }}
      >
        {/* Copilot Metadata */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Metadata
        </h1>
        {/* Image */}
        <Form.Item label="Image">
          <Upload
            name="image"
            listType="picture-card"
            customRequest={handleUploadImage}
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeImageUpload}
            multiple={false}
            accept="image/*,image/gif"
          >
            {values.image ? (
              <img src={values.image} alt="avatar" style={{ width: "100%" }} />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>

        {/* Name */}
        <Form.Item label="Name">
          <Input
            name="name"
            value={values.name}
            onChange={handleFormChange}
            placeholder="A single word to identify copilot. Ex: backgroundInfo"
          />
        </Form.Item>

        {/* Command */}
        <Form.Item label="Command">
          <Input
            name="command"
            value={values.command}
            onChange={handleFormChange}
            placeholder="Command"
          />
        </Form.Item>

        {/* Description */}
        <Form.Item label="Description">
          <Input
            name="description"
            value={values.description}
            onChange={handleFormChange}
            placeholder="Description"
          />
        </Form.Item>

        {/* Category */}
        <Form.Item label="Category">
          <Select
            name="category"
            placeholder="Select a category"
            value={values.category}
            onChange={(value) => {
              setValues({
                ...values,
                category: value,
              });
            }}
          >
            {categories.map((category) => (
              <Select.Option key={category._id} value={category.name}>
                {category.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Plan */}
        <Form.Item label="Plan">
          {/* A copilot can have multiple plans */}
          <Select
            mode="multiple"
            name="plans"
            placeholder="Select plans"
            value={values.plans}
            onChange={(value) => {
              setValues({
                ...values,
                plans: value,
              });
            }}
          >
            {plans.map((plan) => (
              <Select.Option key={plan._id} value={plan.name}>
                {plan.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Order */}
        <Form.Item label="Order">
          <Input
            name="order"
            type="number"
            placeholder="Enter order"
            onChange={handleFormChange}
            value={values.order}
          />
        </Form.Item>

        <Divider />

        {/* Copilot Recipe */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Recipe
        </h1>

        {/* Model */}
        <Form.Item label="Model">
          <Select
            name="model"
            onChange={(value) => {
              setValues({
                ...values,
                model: value,
              });
            }}
            value={values.model}
          >
            <Select.Option value="gpt-3.5-turbo">gpt-3.5-turbo</Select.Option>
          </Select>
        </Form.Item>

        {/* Temperature */}
        <Form.Item label="Temperature">
          <Input
            name="temperature"
            type="number"
            min="0"
            max="1"
            step="0.01"
            placeholder="Enter temperature"
            onChange={handleFormChange}
            value={values.temperature}
          />
        </Form.Item>

        {/* Max tokens */}
        <Form.Item label="Max tokens">
          <Input
            name="max_tokens"
            type="number"
            placeholder="Enter max tokens"
            onChange={handleFormChange}
            value={values.max_tokens}
          />
        </Form.Item>

        {/* Top p */}
        <Form.Item label="Top p">
          <Input
            name="top_p"
            type="number"
            min="0"
            max="1"
            step="0.01"
            placeholder="Enter top p"
            onChange={handleFormChange}
            value={values.top_p}
          />
        </Form.Item>

        {/* Frequency penalty */}
        <Form.Item label="Freq penalty">
          <Input
            name="frequency_penalty"
            type="number"
            min="0"
            max="1"
            step="0.01"
            placeholder="Enter frequency penalty"
            onChange={handleFormChange}
            value={values.frequency_penalty}
          />
        </Form.Item>

        {/* Presence penalty */}
        <Form.Item label="Pres penalty">
          <Input
            name="presence_penalty"
            type="number"
            min="0"
            max="1"
            step="0.01"
            placeholder="Enter presence penalty"
            onChange={handleFormChange}
            value={values.presence_penalty}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default LeftCol;
